import { render, staticRenderFns } from "./CouponsItems.vue?vue&type=template&id=5908cd27&scoped=true&"
import script from "./CouponsItems.vue?vue&type=script&lang=js&"
export * from "./CouponsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908cd27",
  null
  
)

export default component.exports